import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './AImage.module.scss';
import { Picture } from './Picture';
export const AImage = ({ altText, fullWidth: isFullWidth, imageDesktop, imageMobile, isBackground, loading, ...props })=>{
    const description = altText ?? '';
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Picture, {
                asset: imageMobile,
                className: classNames('picture-mobile', Boolean(imageDesktop?.filename) && styles['mobile-is-hidden-on-desktop'], isBackground && styles['mobile-is-background'], props.className),
                "data-testid": "image-mobile",
                description: description,
                isBackground: isBackground,
                isFullWidth: isFullWidth,
                loading: loading,
                maxWidth: props.maxWidth
            }),
            /*#__PURE__*/ _jsx(Picture, {
                asset: imageDesktop,
                className: classNames('picture-desktop', styles.desktop, isBackground && styles['mobile-is-background'], props.className),
                "data-testid": "image-desktop",
                description: description,
                isBackground: isBackground,
                isFullWidth: isFullWidth,
                loading: loading,
                maxWidth: props.maxWidth
            })
        ]
    });
};

//# sourceMappingURL=AImage.js.map